import { useState } from "react";
import { History } from "lucide-react";

const VIA = { agent: "pe ecranul agentului", link: "pe linkul clientului", hartie: "pe hârtie" };
const when = (iso) => new Date(iso).toLocaleString("ro-RO", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const firmHistory = (signed, events, k) => {
  const out = [];
  signed.filter((s) => s.firm === k).forEach((s) => {
    out.push({ at: s.created_at, kind: "semnat", text: `Semnat ${VIA[s.via] || ""}${s.status === "neconfirmat" ? " · așteaptă confirmarea din e-mail" : ""}` });
    if (s.confirmed_at) out.push({ at: s.confirmed_at, kind: "semnat", text: "Confirmat de client din e-mail" });
    if (s.voided_at) out.push({ at: s.voided_at, kind: "anulat", text: `Anulat${s.void_reason ? ` · motiv: ${s.void_reason}` : ""}` });
    if (s.status === "depasit") out.push({ at: s.superseded_at || s.created_at, kind: "anulat", text: "Depășit: datele garanților s-au schimbat" });
  });
  (events || []).filter((e) => e.firm === k).forEach((e) => out.push({ at: e.at, kind: "trimis", text: e.kind === "resign_email" ? `Link de resemnare trimis pe e-mail${e.note ? ` la ${e.note}` : ""}` : "Link de resemnare deschis pe WhatsApp" }));
  const signs = out.filter((x) => x.text.startsWith("Semnat")).sort((a, b) => a.at.localeCompare(b.at));
  signs.slice(1).forEach((x) => { x.text = x.text.replace("Semnat", "Semnat din nou"); });
  return out.sort((a, b) => a.at.localeCompare(b.at));
};

export default function BFFirmHistory({ signed, events, k }) {
  const [open, setOpen] = useState(false);
  const items = firmHistory(signed, events, k);
  if (!items.length) return null;
  return (
    <div className="bf-hist" data-testid={`bf-history-${k}`}>
      <button type="button" className="bf-hist-toggle" onClick={() => setOpen(!open)} data-testid={`bf-history-toggle-${k}`}><History size={13} /> Istoric ({items.length})</button>
      {open && (
        <ol className="bf-hist-list" data-testid={`bf-history-list-${k}`}>
          {items.map((x, i) => <li key={i} className={`is-${x.kind}`} data-testid={`bf-history-item-${k}-${i}`}><time>{when(x.at)}</time><span>{x.text}</span></li>)}
        </ol>
      )}
    </div>
  );
}
